import { useUX } from './context'

export function DemoControls() {
  const { persona, axes, demo, setPersona, setAxis, resetToPreset } = useUX()

  if (!demo) return null

  return (
    <div className="fixed bottom-4 right-4 bg-white border-2 border-gray-300 rounded-lg shadow-lg p-4 w-80 z-50 dark:bg-gray-800 dark:border-gray-700">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-bold text-lg dark:text-gray-100">UX Demo Controls</h3>
        <button
          onClick={resetToPreset}
          className="text-xs bg-gray-200 hover:bg-gray-300 px-2 py-1 rounded dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200"
        >
          Reset
        </button>
      </div>

      {/* Persona toggle */}
      <div className="mb-4">
        <label className="block text-sm font-semibold mb-2 dark:text-gray-200">Persona</label>
        <div className="flex gap-2">
          <button
            onClick={() => setPersona('recruiter')}
            className={`flex-1 px-3 py-2 rounded ${
              persona === 'recruiter'
                ? 'bg-blue-500 text-white dark:bg-blue-600'
                : 'bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200'
            }`}
          >
            Recruiter
          </button>
          <button
            onClick={() => setPersona('engineer')}
            className={`flex-1 px-3 py-2 rounded ${
              persona === 'engineer'
                ? 'bg-blue-500 text-white dark:bg-blue-600'
                : 'bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200'
            }`}
          >
            Engineer
          </button>
        </div>
      </div>

      {/* Axes sliders */}
      <div className="space-y-3">
        {(['density', 'depth', 'motion'] as const).map((axis) => (
          <div key={axis}>
            <label className="block text-sm font-medium mb-1 capitalize dark:text-gray-200">
              {axis}: {axes[axis].toFixed(2)}
            </label>
            <input
              type="range"
              min="0"
              max="1"
              step="0.01"
              value={axes[axis]}
              onChange={(e) => setAxis(axis, parseFloat(e.target.value))}
              className="w-full"
            />
            <div className="flex justify-between text-xs text-gray-500 mt-1 dark:text-gray-400">
              <span>{axis === 'density' ? 'Airy' : axis === 'depth' ? 'Overview' : 'Minimal'}</span>
              <span>{axis === 'density' ? 'Compact' : axis === 'depth' ? 'Detailed' : 'Rich'}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4 text-xs text-gray-500 dark:text-gray-400">
        <p>
          Persona: <strong>{persona}</strong>
        </p>
        <p>URL synced + localStorage persisted</p>
      </div>
    </div>
  )
}
